import { ICartEntryDetailsReward, isServiceRewardDetails } from './types';

export type InRestaurantRewardApplicationTarget =
  | {
      cartId: string;
      reward: {
        id: string;
        cmsId?: string;
        rewardBenefitId: string;
        pointCost: number;
        limitPerOrder?: number;
      };
    }
  | {
      cartId: string;
      rewardBenefitId: string;
    };

export const getInRestaurantRewardApplicationTarget = (
  details: ICartEntryDetailsReward
): InRestaurantRewardApplicationTarget | undefined => {
  if (isServiceRewardDetails(details)) {
    const { reward } = details;
    if (!reward.rewardBenefitId) {
      return undefined;
    }

    return {
      cartId: reward.id,
      reward: {
        id: reward.id,
        cmsId: reward.cmsId,
        rewardBenefitId: reward.rewardBenefitId,
        pointCost: reward.pointCost,
        limitPerOrder: reward.limitPerOrder,
      },
    };
  }

  const { engineReward } = details;
  if (!engineReward.rewardBenefitId) {
    return undefined;
  }

  return {
    cartId: engineReward.id,
    rewardBenefitId: engineReward.rewardBenefitId,
  };
};
